export const changeSentinel2NDVILayerReducer = (state = false, action) => {
  switch (action.type) {
    case "CHANGE_SENTINEL2_NDVI_Layer":
      return action.payload.sentinel2NdviLayer;
    default:
      return state;
  }
};
